import * as React from "react"
import type { SVGProps } from "react"
const SvgPages = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 22.86q-.82 0-1.41-.59A2 2 0 0 1 2 20.86v-9q0-.83.59-1.41A2 2 0 0 1 4 9.85h2v-5q0-.81.59-1.4A2 2 0 0 1 8 2.84h12q.83 0 1.41.6.6.59.59 1.4v9q0 .84-.59 1.42a2 2 0 0 1-1.41.59h-2v5q0 .83-.59 1.41a2 2 0 0 1-1.41.59zm0-2h12v-7H4zm14-7h2v-7H8v3h8q.83 0 1.41.58.6.6.59 1.42z" />
  </svg>
)
export default SvgPages
